import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getAppStoreLinks = () => {
  return axios()({
    method: "get",
    url: `${API.COMMON_V2}${API.APP_STORE_LINKS}`,
  });
};
